export const ENDPOINT = "https://okr.smartx.com";
export const GRAPHQL_ENDPOINT = "https://fegate.smartx.com/okr";

export const COMMENT_HINT = "添加评论（Enter 换行，Command/Ctrl + Enter 发送）";
